import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  remove(_event) {
    this.element.parentNode.removeChild(this.element);
  }
}
